import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobAiaActions'
import * as api from '../../api/job/aias'

function* jobAiasRefresh(action) {
  try {
    let payload = []
    if (action.fromDashboard) {
      const assignedToId = action.assignedToId ? action.assignedToId : 0
      payload = yield call(api.getDashboardAias, assignedToId)
    } else {
      payload = yield call(api.getJobAias, action.jobId)
    }
    yield put({ type: constants.JOB_AIAS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_AIAS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobAias() {
  yield takeLatest(constants.JOB_AIAS_REFRESH.ACTION, jobAiasRefresh)
}

function* sagaCreateJobAia(action) {
  try {
    const payload = {
      formData: action.formData,
      job_id: action.jobId
    }

    yield call(api.createJobAia, payload)
    yield put({ type: constants.JOB_AIA_CREATE.SUCCESS, payload })
    yield call(jobAiasRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_AIA_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobAia() {
  yield takeLatest(constants.JOB_AIA_CREATE.ACTION, sagaCreateJobAia)
}

function* sagaUpdateJobAia(action) {
  try {
    const payload = {
      job_id: action.jobId,
      job_aia_id: action.aiaId,
      content: action.content,
      updated_by_id: action.userId,
      user_id: action.userId
    }
    yield call(api.updateJobAia, payload)
    yield put({ type: constants.JOB_AIA_UPDATE.SUCCESS, payload })
    yield call(jobAiasRefresh, {
      jobId: action.jobId,
      fromDashboard: action.content.fromDashboard,
      assignedToId: action.content.selectedUser
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_AIA_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobAia() {
  yield takeLatest(constants.JOB_AIA_UPDATE.ACTION, sagaUpdateJobAia)
}

function* sagaDeleteJobAia(action) {
  try {
    const payload = {
      job_aia_id: action.aiaId
    }
    yield call(api.deleteJobAia, payload)
    yield put({ type: constants.JOB_AIA_DELETE.SUCCESS, payload })
    yield call(jobAiasRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_AIA_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobAia() {
  yield takeLatest(constants.JOB_AIA_DELETE.ACTION, sagaDeleteJobAia)
}

// ATTACHMENT SAGAS
function* uploadAiaAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      aiaId: action.aiaId
    }

    yield call(api.uploadAiaAttachments, payload)
    yield put({ type: constants.UPLOAD_AIA_ATTACHMENT.SUCCESS, payload })
    yield call(getAiaAttachments, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_AIA_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAiaAttachments() {
  yield takeLatest(constants.UPLOAD_AIA_ATTACHMENT.ACTION, uploadAiaAttachments)
}

function* getAiaAttachments(action) {
  try {
    const payload = yield call(api.getAiaAttachments, action.aiaId)
    yield put({ type: constants.GET_AIA_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_AIA_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAiaAttachments() {
  yield takeLatest(constants.GET_AIA_ATTACHMENTS.ACTION, getAiaAttachments)
}

function* updateAiaAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_AIA_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAiaAttachments, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_AIA_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAiaAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_AIA_ATTACHMENT_DESCRIPTION.ACTION,
    updateAiaAttachmentDescription
  )
}

function* deleteAiaAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      aiaId: action.aiaId
    }

    yield call(api.deleteAiaAttachment, payload)
    yield put({ type: constants.DELETE_AIA_ATTACHMENT.SUCCESS, payload })
    yield call(getAiaAttachments, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_AIA_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAiaAttachments() {
  yield takeLatest(constants.DELETE_AIA_ATTACHMENT.ACTION, deleteAiaAttachment)
}

function* getAiaActivities(action) {
  try {
    const payload = yield call(api.getJobAiaActivities, action.aiaId)
    yield put({ type: constants.GET_AIA_ACTIVITIES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_AIA_ACTIVITIES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAiaActivities() {
  yield takeLatest(constants.GET_AIA_ACTIVITIES.ACTION, getAiaActivities)
}

// notes
function* fetchAiaNote(action) {
  try {
    const payload = yield call(api.fetchAiaNote, { aiaId: action.aiaId })
    yield put({ type: constants.GET_AIA_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_AIA_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchAiaNote() {
  yield takeLatest(constants.GET_AIA_NOTE.ACTION, fetchAiaNote)
}

function* createAiaNote(action) {
  try {
    const payload = {
      content: action.content,
      aiaId: action.aiaId
    }
    yield call(api.createAiaNote, payload)
    yield put({ type: constants.CREATE_AIA_NOTE.SUCCESS, payload })
    yield call(fetchAiaNote, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_AIA_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateAiaNote() {
  yield takeLatest(constants.CREATE_AIA_NOTE.ACTION, createAiaNote)
}

function* editAiaNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editAiaNote, payload)
    yield put({ type: constants.EDIT_AIA_NOTE.SUCCESS, payload })
    yield call(fetchAiaNote, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_AIA_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditAiaNote() {
  yield takeLatest(constants.EDIT_AIA_NOTE.ACTION, editAiaNote)
}

function* deleteAiaNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteAiaNote, payload)
    yield put({ type: constants.DELETE_AIA_NOTE.SUCCESS, payload })
    yield call(fetchAiaNote, { aiaId: action.aiaId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_AIA_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAiaNote() {
  yield takeLatest(constants.DELETE_AIA_NOTE.ACTION, deleteAiaNote)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobAias),

    fork(watchUploadAiaAttachments),
    fork(watchGetAiaAttachments),
    fork(watchUpdateAiaAttachmentDescription),
    fork(watchDeleteAiaAttachments),

    fork(watchCreateJobAia),
    fork(watchUpdateJobAia),
    fork(watchDeleteJobAia),
    fork(watchGetAiaActivities),

    //notes
    fork(watchFetchAiaNote),
    fork(watchCreateAiaNote),
    fork(watchEditAiaNote),
    fork(watchDeleteAiaNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobAiaSaga.js